<mat-form-field subscriptSizing="dynamic">
    @if (ngControl?.control) {
        <input
            type="number"
            matInput
            [min]="minValue"
            [max]="maxValue"
            [attr.data-uiid]="dataUiid"
            [placeholder]="placeholder"
            [formControl]="$any(ngControl!.control)"
            (input)="onChange($event)"
            [errorStateMatcher]="errorMatcher"
            (keydown)="onKeydown($event)"
        />
    } @else {
        <input
            #numericInput
            type="number"
            matInput
            [min]="minValue"
            [max]="maxValue"
            [attr.data-uiid]="dataUiid"
            [placeholder]="placeholder"
            [disabled]="disabled"
            [ngModel]="value"
            (input)="onChange($event)"
            (keydown)="onKeydown($event)"
        />
    }

    @for (error of ngControl?.control?.errors | errorMessages; track error) {
        <mat-error>{{ error }}</mat-error>
    }
</mat-form-field>
